import {ProverbService} from './proverb.service';
import {ProverbBookmarkService} from './proverb-bookmark.service';
import {ProverbHistoryService} from './proverb-history.service';

export const ProverbInjectables: Array<any> = [
  {
    provide: ProverbService,
    useClass: ProverbService,
  },
  {
    provide: ProverbBookmarkService,
    useClass: ProverbBookmarkService,
  },
  {
    provide: ProverbHistoryService,
    useClass: ProverbHistoryService,
  },
];
